import { AssetType } from "@zapier/canvas-state";

export function getButtonNameByTheAssetType(assetType: AssetType) {
  switch (assetType) {
    case "zap":
      return "Go to Zap";
    case "interface":
      return "Go to Interface";
    case "table":
      return "Go to Table";
    case "chatbot":
      return "Go to Chatbot";
    case "agent":
      return "Go to Agent";
    default:
      return "Go to Zap";
  }
}
